import React, { useState } from "react";
import { Linkedin, Youtube, Instagram } from "react-feather";
import logo from "../Assets/BrandLogo/whitelogo.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThreeDots } from "react-loader-spinner";

function Footer() {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);

  const subEmail = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email.trim()) {
      toast.error("Email is required");
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setLoader(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASEURL}/api/management/subscribe-email/`,
        { email }
      );
      setLoader(false);
      toast.success("Subscribed successfully!");
      setEmail("");
    } catch (error) {
      setLoader(false);
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <footer className="bg-[#14213d] text-white py-10 px-6 md:px-16 lg:px-32 ">
      <ToastContainer />
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Legal Section */}
        <div>
          <h3 className="font-semibold text-lg">Legal</h3>
          <ul className="mt-2 space-y-1">
            <li>
              <a href="/privacy-policy" className="hover:underline">
                Privacy Policy
              </a>
            </li>
            <li>
              <a href="/terms-conditions" className="hover:underline">
                Terms of Service
              </a>
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div>
          <h3 className="font-semibold text-lg">Contact</h3>
          <p className="mt-2">Lake Town, Kolkata, India, 700089</p>
          {/* <p>+91 9002841677</p> */}
          <p>contact@labops.in</p>
        </div>

        {/* Stay Updated Section */}
        <div>
          <h3 className="font-semibold text-lg">Stay Updated</h3>
          <p className="mt-2">
            Sign up for our newsletter to receive the latest updates and special
            offers.
          </p>
          <div className="mt-3">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your Email Address"
              className="w-full px-4 py-2 rounded-md bg-white/20 placeholder-white border border-white focus:outline-none focus:ring-2 focus:ring-white"
            />
            <button
              onClick={subEmail}
              className="w-full mt-2 flex justify-center items-center bg-[#1F4194] hover:bg-[#19377A] text-white h-[3rem] rounded-md"
            >
              {loader ? (
                <ThreeDots
                  visible
                  height="50"
                  width="50"
                  color="white"
                  ariaLabel="loading"
                />
              ) : (
                "Subscribe"
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="text-center mt-10 text-white text-sm">
        &copy; {new Date().getFullYear()} Labops. All Rights Reserved. Designed
        by Labops.
      </div>
    </footer>
  );
}

export default Footer;
